export const MAX_DEVICE_WIDTH_FORM = 460
export const MAX_DEVICE_WIDTH_MOBILE = 767
export const MAX_DEVICE_WIDTH_TABLET = 800
export const MAX_DEVICE_WIDTH_DESKTOP = 1224
export const SIDEBAR_WIDTH = 250
